<template>
  <div class="p-6">
    <vx-card title="ตัวอย่างการรับ-ส่งข้อความแบบเรียลไทม์">
      <div class="vx-row mb-4">
        <div class="vx-col w-full md:w-2/3">
          <label class="text-sm font-semibold">ข้อความ</label>
          <vs-input
            v-model="message"
            class="w-full mt-2"
            placeholder="พิมพ์ข้อความ"
            :disabled="status.processing"
          />
        </div>
        <div class="vx-col w-full md:w-1/3 flex items-end justify-end mt-4 md:mt-0">
          <vs-button :disabled="!message || status.processing" @click="onSendMessage">
            {{ status.processing ? 'กำลังส่ง...' : 'ส่งข้อความ' }}
          </vs-button>
        </div>
      </div>

      <vs-alert
        v-if="status.error"
        class="mb-4"
        color="danger"
        icon-pack="feather"
        icon="icon-alert-triangle"
        :title="status.error.title || 'เกิดข้อผิดพลาด'"
      >
        <span>{{ status.error.text || status.error }}</span>
      </vs-alert>

      <vs-divider position="center">ข้อความล่าสุด</vs-divider>
      <div class="message-log">
        <div v-if="sampleMessages.length === 0" class="text-center py-6 text-grey">
          ยังไม่มีข้อความเข้ามา
        </div>
        <div
          v-for="item in sampleMessages"
          :key="item.id"
          class="message-row"
        >
          <div class="flex justify-between items-start">
            <div class="font-semibold break-words">{{ item.message }}</div>
            <small class="text-grey">{{ formatDate(item.sentAt) }}</small>
          </div>
          <small class="text-grey">ID: {{ item.id }}</small>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const moment = require('moment');

const { mapActions, mapState } = createNamespacedHelpers('Sample')

export default {
  name: 'SampleMessage',
  data() {
    return {
      message: ''
    }
  },
  computed: {
    ...mapState(['sampleMessages', 'status'])
  },
  async created() {
    await this.subscribeSampleMessages()
  },
  beforeDestroy() {
    this.stopSampleSubscription()
  },
  methods: {
    ...mapActions(['publishSampleMessage', 'subscribeSampleMessages', 'stopSampleSubscription']),
    async onSendMessage() {
      if (!this.message) return
      await this.publishSampleMessage({message: this.message})
      this.message = ''
    },
    formatDate(value) {
      return value ? moment(value).format('YYYY-MM-DD HH:mm:ss') : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.message-log {
  max-height: 360px;
  overflow-y: auto;
}

.message-row {
  padding: 12px 0;
  border-bottom: 1px solid #ececec;
}
</style>
